import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import cn from 'classname';
import noop from 'lodash/noop';
import flatten from 'lodash/flatten';

const Table = (props) =>
	<div className="table-container">
		<table className="simple-table adv-requests-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{ props.table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								'active': props.table.sortedColumn.index === header.index,
								[header.className]: header.className,
								[props.table.sortedColumn.direction]: (
									props.table.sortedColumn.index === header.index && props.table.sortedColumn.direction
								)
							})}
							onClick={() => header.direction ? props.sortByColumn(header.index) : noop}>{props.intl(header.title)}</th>
					))}
				</tr>
			</thead>

			<tbody className="simple-table__body">
				{getGroupedRows(props)}
			</tbody>
		</table>
		<div className="table-container__pagination">
			<div className="table-container__pagination-items">
				{props.pagination.pages.map(pageIndex => {
					const page = ++pageIndex;
					return (
						<a
							key={page}
							href="#"
							className={cn({
								'table-container__pagination-item': true,
								active: page === props.pagination.currentPage
							})}
							onClick={e => {
								e.preventDefault();
								props.gotoPage(page);
							}}
						>
							{page}
						</a>
					);
				})}
			</div>
		</div>
	</div>;

Table.propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	deleteRequest: PropTypes.func,
	viewRequestDetails: PropTypes.func,
	can: PropTypes.func
};

// functions

const getDate = (row, intl) => {
	const date = row.created_at;
	return (
		<span>
			{moment(date).format('DD.MM.YYYY')}{' '}
			{intl('at')}{' '}
			<span className="time">{moment(date).format('HH:mm')}</span>
		</span>
	);
};

const getGroupedRows = props => {
	let res = [];

	const [unread, inWork] = props.table.rows;
	const { pagination: { total, currentPage } } = props;

	if (unread.data.length) {
		res = [].concat(res, makeGroupRow({
			groupRow: unread,
			totalRows: unread.data.length,
			shouldShowGroupHeader: true,
			props
		}));
	}
	if (inWork.data.length) {
		const totalRows = Number(total) - unread.data.length;
		res = [].concat(res, makeGroupRow({
			groupRow: inWork,
			totalRows: totalRows,
			shouldShowGroupHeader: currentPage === 1,
			props
		}));
	}

	return res;
};

const makeGroupRow = ({ groupRow, totalRows, shouldShowGroupHeader, props }) => {
	const res = [];

	shouldShowGroupHeader && res.push(
		<tr key={groupRow.name} className={`group--${groupRow.className}`}>
			<td colSpan="9">
				<span className="title font-roboto-bold">{props.intl(groupRow.name)}</span>
				<span className="count">{totalRows}</span>
			</td>
		</tr>
	);
	res.push(
		flatten(
			groupRow.data.map((entity, i) => <tr
				key={i}
				className={cn({
					'modify-background': i % 2,
					'read': entity.admin_viewed
				})}
			>
				<td>
					<span>{getDate(entity, props.intl)}</span>
				</td>
				<td className="name">{entity.name}</td>
				<td className="email">{entity.email}</td>
				<td className="product">{entity.product}</td>
				<td className="web-site">{entity.website}</td>
				<td className="reward">{entity.payout}</td>
				<td className="actions">
					<span onClick={e => props.viewRequestDetails(entity.id)} className="action_view"/>
				</td>
			</tr>)
		)
	);

	return res;
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/advertisers-requests/components/table/main.js